import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const modal = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: handlers.openModal,
    closeModal: handlers.closeModal,
  },
});

export const { actions, reducer } = modal;
export const { openModal, closeModal } = actions;

export default reducer;
